// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"4b527300","729":"709e7520"}[chunkId] + ".chunk.css";
};